module.exports = __webpack_public_path__ + "img/86073284.aee19d0a.png";